'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelectAsyncPaginate = require('react-select-async-paginate');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ArrowIcon = require('../ArrowIcon/ArrowIcon');

var _ArrowIcon2 = _interopRequireDefault(_ArrowIcon);

var _CustomDropdownInput = require('../CustomDropdownInput/CustomDropdownInput');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
    'rootFontSize': '10px',
    'fontSizeXSmall': '0.8rem',
    'fontSizeSmaller': '1.1rem',
    'fontSizeSmall': '1.2rem',
    'fontSizeMediumSmall': '1.3rem',
    'fontSizeMedium': '1.4rem',
    'fontSizeLarge': '1.6rem',
    'fontSizeLarger': '1.8rem',
    'fontSizeXLarge': '2rem',
    'fontSizeXxLarge': '3.2rem',
    'maxWidthMobile': '480px',
    'userMenuLayer': '3',
    'defaultBorderThickness': '1px',
    'taboola-svg-icon': 'asyncDropdown__taboola-svg-icon___3jt82',
    'container': 'asyncDropdown__container___1LIhP'
};


var AVAILABLE_DELTA = 30;
var MenuList = (0, _reactSelectAsyncPaginate.wrapMenuList)(_reactSelect.components.MenuList);
var classNameBuilder = _bind2.default.bind(styles);

var AsyncDropdown = function (_Component) {
    _inherits(AsyncDropdown, _Component);

    function AsyncDropdown() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        _classCallCheck(this, AsyncDropdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AsyncDropdown.__proto__ || Object.getPrototypeOf(AsyncDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            resetCache: {},
            retryLoad: false,
            menuOpen: _this.props.menuIsOpen
        }, _this.handleMenuOpen = function () {
            var onMenuOpen = _this.props.onMenuOpen;

            _this.setState({ menuOpen: true });
            onMenuOpen();
        }, _this.handleMenuClose = function () {
            var onMenuClose = _this.props.onMenuClose;

            _this.setState({ menuOpen: false });
            onMenuClose();
        }, _this.shouldLoadMore = function (scrollHeight, clientHeight, scrollTop) {
            var error = _this.props.error;

            if (error) {
                return false;
            }

            var bottomBorder = scrollHeight - clientHeight - AVAILABLE_DELTA;
            return bottomBorder < scrollTop;
        }, _this.loadOptions = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(inputValue) {
                var _this$props, getOptions, error, _ref3, _ref3$options, options, _ref3$hasMore, hasMore;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this$props = _this.props, getOptions = _this$props.getOptions, error = _this$props.error;

                                if (!error) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return', { options: [], hasMore: false });

                            case 3:
                                _context.next = 5;
                                return getOptions(inputValue);

                            case 5:
                                _ref3 = _context.sent;
                                _ref3$options = _ref3.options;
                                options = _ref3$options === undefined ? [] : _ref3$options;
                                _ref3$hasMore = _ref3.hasMore;
                                hasMore = _ref3$hasMore === undefined ? true : _ref3$hasMore;
                                return _context.abrupt('return', {
                                    options: options, hasMore: hasMore
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }(), _this.filterOptions = function () {
            var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _option$value = option.value,
                value = _option$value === undefined ? '' : _option$value;
            var _this$props2 = _this.props,
                _this$props2$blacklis = _this$props2.blacklist,
                blacklist = _this$props2$blacklis === undefined ? [] : _this$props2$blacklis,
                whitelist = _this$props2.whitelist;


            if (whitelist) {
                if (!whitelist.includes(value)) {
                    return false;
                }
            }

            return !blacklist.includes(value);
        }, _this.handleOnInputChange = function (inputValue, _ref4) {
            var action = _ref4.action;
            var onInputChange = _this.props.onInputChange;


            if (action === 'input-change') {
                onInputChange(inputValue);
            }
        }, _this.handleRetry = function () {
            var onRetry = _this.props.onRetry;

            onRetry();
            _this.setState({ retryLoad: true, resetCache: {} }, function () {
                _this.setState({ retryLoad: false });
            });
        }, _this.renderMenuList = function (_ref5) {
            var children = _ref5.children,
                options = _ref5.options,
                isLoading = _ref5.isLoading,
                props = _objectWithoutProperties(_ref5, ['children', 'options', 'isLoading']);

            var _this$props3 = _this.props,
                error = _this$props3.error,
                hasMore = _this$props3.hasMore,
                RetryComponentRenderer = _this$props3.retryComponentRenderer,
                LoadingMessage = _this$props3.loadingMessageRenderer;


            var needLoadingComponent = !error && hasMore && options.filter(_this.filterOptions).length;
            var needRetry = error && !isLoading;

            return _react2.default.createElement(
                MenuList,
                Object.assign({ isLoading: isLoading, options: options }, props),
                children,
                RetryComponentRenderer && needRetry ? _react2.default.createElement(RetryComponentRenderer, Object.assign({ onRetry: _this.handleRetry }, props)) : null,
                needLoadingComponent ? _react2.default.createElement(LoadingMessage, Object.assign({ isLoading: isLoading, options: options }, props)) : null
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AsyncDropdown, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                selectedValueObject = _props.selectedValueObject,
                disabled = _props.disabled,
                searchable = _props.searchable,
                clearable = _props.clearable,
                backspaceRemoves = _props.backspaceRemoves,
                className = _props.className,
                debounceMillis = _props.debounceMillis,
                arrowRenderer = _props.arrowRenderer,
                valueRenderer = _props.valueRenderer,
                multiValueRenderer = _props.multiValueRenderer,
                loadingMessageRenderer = _props.loadingMessageRenderer,
                optionLabelRenderer = _props.optionLabelRenderer,
                optionRenderer = _props.optionRenderer,
                valueContainerRenderer = _props.valueContainerRenderer,
                getOptions = _props.getOptions,
                options = _props.options,
                onBlur = _props.onBlur,
                blacklist = _props.blacklist,
                whitelist = _props.whitelist,
                menuIsOpen = _props.menuIsOpen,
                manualMenuControl = _props.manualMenuControl,
                blurInputOnSelect = _props.blurInputOnSelect,
                rest = _objectWithoutProperties(_props, ['selectedValueObject', 'disabled', 'searchable', 'clearable', 'backspaceRemoves', 'className', 'debounceMillis', 'arrowRenderer', 'valueRenderer', 'multiValueRenderer', 'loadingMessageRenderer', 'optionLabelRenderer', 'optionRenderer', 'valueContainerRenderer', 'getOptions', 'options', 'onBlur', 'blacklist', 'whitelist', 'menuIsOpen', 'manualMenuControl', 'blurInputOnSelect']);

            var _state = this.state,
                resetCache = _state.resetCache,
                retryLoad = _state.retryLoad,
                menuOpen = _state.menuOpen;


            var containerClassName = classNameBuilder(_defineProperty({
                container: true,
                Select: true
            }, className, className));

            var menuState = manualMenuControl ? menuIsOpen : menuOpen;

            return _react2.default.createElement(_reactSelectAsyncPaginate.AsyncPaginate, Object.assign({}, rest, {
                menuIsOpen: menuState,
                onMenuOpen: this.handleMenuOpen,
                onMenuClose: this.handleMenuClose,
                classNamePrefix: 'Select',
                defaultOptions: retryLoad || options,
                blurInputOnSelect: blurInputOnSelect,
                value: selectedValueObject,
                loadOptions: this.loadOptions,
                isSearchable: searchable,
                isDisabled: disabled,
                isClearable: clearable,
                backspaceRemovesValue: backspaceRemoves,
                className: containerClassName,
                shouldLoadMore: this.shouldLoadMore,
                onBlur: onBlur || undefined,
                debounceTimeout: debounceMillis,
                onInputChange: this.handleOnInputChange,
                formatOptionLabel: optionLabelRenderer,
                cacheUniq: resetCache,
                filterOption: blacklist || whitelist ? this.filterOptions : undefined,
                components: {
                    IndicatorSeparator: null,
                    LoadingIndicator: null,
                    DropdownIndicator: arrowRenderer,
                    SingleValue: valueRenderer,
                    MultiValue: multiValueRenderer,
                    Option: optionRenderer,
                    LoadingMessage: loadingMessageRenderer,
                    MenuList: this.renderMenuList,
                    ValueContainer: valueContainerRenderer,
                    Input: _CustomDropdownInput.CustomDropdownInput
                }
            }));
        }
    }]);

    return AsyncDropdown;
}(_react.Component);

var selectedValueObjectPropType = _propTypes2.default.shape({ value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]), label: _propTypes2.default.string });

AsyncDropdown.propTypes = {
    /** html id to set on the input element for accessibility or tests */
    id: _propTypes2.default.string,
    /** autofocus the component on mount */
    autoFocus: _propTypes2.default.bool,
    /** array of options */
    options: _propTypes2.default.array,
    /** should it be possible to reset value */
    clearable: _propTypes2.default.bool,
    /** field name, for hidden <input /> tag */
    name: _propTypes2.default.string,
    /** whether the component is disabled or not */
    disabled: _propTypes2.default.bool,
    /** lose focus on backspace pressed */
    backspaceRemoves: _propTypes2.default.bool,
    /** onChange handler: function(newOption) {} */
    onChange: _propTypes2.default.func.isRequired,
    /** whether to enable searching feature or not */
    searchable: _propTypes2.default.bool,
    /** className for the outer element */
    className: _propTypes2.default.string,
    /** className for the wrapper of OptionRenderer */
    optionClassName: _propTypes2.default.string,
    /** field placeholder, displayed when there's no value */
    placeholder: _propTypes2.default.node,
    /** selected field value */
    selectedValueObject: _propTypes2.default.oneOfType([selectedValueObjectPropType, _propTypes2.default.arrayOf(selectedValueObjectPropType)]),
    /** debounce in millis */
    debounceMillis: _propTypes2.default.number,
    /** function which returns a custom way to render the value selected function (option) {} */
    valueRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the value container function (option) {} */
    valueContainerRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the multi value selected function (option) {} */
    multiValueRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the arrow */
    arrowRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the option label */
    optionLabelRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the option */
    optionRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the loading component */
    loadingMessageRenderer: _propTypes2.default.func,
    /** function which returns a custom way to render the retry component in case of failure */
    retryComponentRenderer: _propTypes2.default.func,
    /** function that returns a promise, which is the set of options to be used once the promise resolves */
    getOptions: _propTypes2.default.func.isRequired,
    /** whether the select is expanded */
    menuIsOpen: _propTypes2.default.bool,
    /** whether this component should handle opening and closing the component */
    manualMenuControl: _propTypes2.default.bool,
    /** input value, used for filtering options */
    inputValue: _propTypes2.default.string,
    /** onInputChange handler: function(inputValue) {} */
    onInputChange: _propTypes2.default.func,
    /** indication to show/hide loading indicator */
    hasMore: _propTypes2.default.bool,
    /** onblur callback of react select */
    onBlur: _propTypes2.default.func,
    /** list of values to filter out */
    blacklist: _propTypes2.default.array,
    /** list of values to keep in */
    whitelist: _propTypes2.default.array,
    /** error object */
    error: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
    /** onRetry handler: function() {} */
    onRetry: _propTypes2.default.func,
    onMenuClose: _propTypes2.default.func,
    onMenuOpen: _propTypes2.default.func,
    blurInputOnSelect: _propTypes2.default.bool
};

AsyncDropdown.defaultProps = {
    inputValue: '',
    options: [],
    menuIsOpen: false,
    manualMenuControl: false,
    onInputChange: function onInputChange() {},
    valueRenderer: _reactSelect.components.SingleValue,
    valueContainerRenderer: _reactSelect.components.ValueContainer,
    multiValueRenderer: _reactSelect.components.MultiValue,
    arrowRenderer: _ArrowIcon2.default,
    loadingMessageRenderer: _reactSelect.components.LoadingMessage,
    optionRenderer: _reactSelect.components.Option,
    onRetry: function onRetry() {},
    debounceMillis: 250,
    onMenuClose: function onMenuClose() {},
    onMenuOpen: function onMenuOpen() {},
    blurInputOnSelect: true
};

exports.default = AsyncDropdown;